import React from 'react';
import { Layers } from 'lucide-react';

import { MAP_LAYERS } from './layers';

/**
 * Choix du fond de carte, en pastilles à poser sur la carte (dans l'`overlay`
 * de `MapSurface`, dans un conteneur positionné par l'écran). Le Satellite n'est proposé que si la clé Esri
 * est posée: la liste vient de `MAP_LAYERS`.
 */
export default function SelecteurFond({ valeur, onChange, className = '' }) {
  const fonds = Object.entries(MAP_LAYERS);
  if (fonds.length < 2) return null;
  return (
    <div
      role="group"
      aria-label="Fond de carte"
      className={`flex flex-wrap items-center gap-1 rounded-lg border border-border bg-card/90 p-1 shadow-sm backdrop-blur-sm ${className}`}
    >
      <Layers className="ml-1 h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
      {fonds.map(([cle, fond]) => (
        <button
          key={cle}
          type="button"
          aria-pressed={valeur === cle}
          onClick={() => onChange(cle)}
          className={`rounded-md px-2 py-0.5 text-xs font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
            valeur === cle
              ? 'bg-info text-info-foreground'
              : 'text-muted-foreground hover:bg-muted hover:text-foreground'
          }`}
        >
          {fond.label}
        </button>
      ))}
    </div>
  );
}
